import { render, staticRenderFns } from "./mylucky.vue?vue&type=template&id=4cb7723a&"
import script from "./mylucky.vue?vue&type=script&lang=js&"
export * from "./mylucky.vue?vue&type=script&lang=js&"
import style0 from "./mylucky.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports